const BRANCH = process.env.GATSBY_CIRCLE_BRANCH || process.env.REACT_APP_BRANCH;

// const BASE_ENV = 'development';
// const BASE_ENV = 'local';
const BASE_ENV = 'master';

export const ENV = BRANCH || process.env.GATSBY_ENV || process.env.REACT_APP_ENV || BASE_ENV;

const SERVER_PORT =
  process.env.GATSBY_SERVER_PORT || process.env.REACT_APP_SERVER_PORT || process.env.SERVER_PORT || 8080;
console.log(SERVER_PORT);
console.log('...................................');

const isLocal = ENV === 'local';
// local-proxy: FE served from CRA dev origin proxies all API calls
// same-origin to the local server_pray. SERVER_BASE_URI is '' so axios
// uses relative URLs; setupProxy.js forwards /0.13 and /web to the local
// server. Preserves Secure cookies that would be dropped on cross-origin XHR.
const isLocalProxy = ENV === 'local-proxy';
const isDevelopment = ENV === 'development';
const isQa1 = ENV === 'qa-1';
const isQa2 = ENV === 'qa-2';
const isQa3 = ENV === 'qa-3';
export const isProduction = ENV === 'master';
export const isSuperfunnelDemo = ENV === 'superfunnel-demo';
export const isDemoRollout = ENV === 'demo-rollout';

// --------------------------------------------------------------------------------------------
// Amplitude
// --------------------------------------------------------------------------------------------
export const AMPLITUDE_KEY = isProduction ? '7ca06da5bfe6f27a1476000996f3976b' : '6dd21fb20998eaf79faa3127f044ef1c';

// --------------------------------------------------------------------------------------------
// Braze
// --------------------------------------------------------------------------------------------
export const BRAZE_KEY = isProduction ? '9daa669b-32d8-46ff-a3d1-28cd99944750' : '98302c51-dd6a-455f-9196-11fc06926b7f';

export const BRAZE_SDK_ENDPOINT = 'sdk.iad-06.braze.com';

// --------------------------------------------------------------------------------------------
// Branch
// --------------------------------------------------------------------------------------------
export const BRANCH_KEY = isProduction
  ? 'key_live_pkFEvDVs2m1ekLDOtnbwKhadDvePet44'
  : 'key_test_foCszDGB7e7pcVDTqkfEIhlkszkOoSin';

// --------------------------------------------------------------------------------------------
// Facebook Pixel
// --------------------------------------------------------------------------------------------
export const FACEBOOK_PIXEL_ID = '120473298572141';

// Dedicated dataset the SuperFunnel ad account optimizes on. Fired only on the
// SuperFunnel landing page(s), in addition to the site-wide pixel above, so the
// SuperFunnel campaign can see landing-page events and match CAPI conversions.
export const SUPERFUNNEL_FACEBOOK_PIXEL_ID = '957504709754141';

// --------------------------------------------------------------------------------------------
// Microsoft Clarity
// --------------------------------------------------------------------------------------------
// Session analytics for the ministry-partner landing pages (SuperFunnel, donor-calculator,
// grow-donations, salvations). Loaded per-page, gated by the same tracking-consent check as
// the Facebook pixel.
export const MICROSOFT_CLARITY_PROJECT_ID = 'x3z0c31975';

// --------------------------------------------------------------------------------------------
// Google Analytics
// --------------------------------------------------------------------------------------------
export const GOOGLE_ANALYTICS_KEY = isProduction ? 'G-F4CZ9W1XY7' : 'G-NHMGS90PL5';

// --------------------------------------------------------------------------------------------
// Google Recaptcha v3
// --------------------------------------------------------------------------------------------
export const GOOGLE_RECAPTCHA_SITE_KEY = isProduction
  ? '6Leo5dclAAAAAP2knqbHvUmqphcxUn_JlaemqrTy'
  : '6Lcf6tclAAAAADhZCE6GMSVKpOMnaKRI28UpLZml';

// --------------------------------------------------------------------------------------------
// Google Maps
// --------------------------------------------------------------------------------------------
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCPIxTPgzpQByZrwI2WiYJye3wN7IEZmFw';

// --------------------------------------------------------------------------------------------
// Stripe
// --------------------------------------------------------------------------------------------
export const STRIPE_API_KEY = isProduction ? 'pk_live_P43ApllnbBivVhS2pEOa1tTV' : 'pk_test_ZVtqNEBpvrfGxKRmAzf6APnI';

// --------------------------------------------------------------------------------------------
// Backend server
// --------------------------------------------------------------------------------------------
const PRODUCTION_API = 'https://api.pray.com';

export const SERVER_BASE_URI = (() => {
  if (isLocal) return `http://localhost:${SERVER_PORT}`;
  // Same-origin: setupProxy.js forwards /0.13 + /web to localhost:8081
  if (isLocalProxy) return '';
  if (isProduction) return PRODUCTION_API;
  if (isDevelopment) return 'https://dev.pray.com';
  if (isDemoRollout) return PRODUCTION_API;
  if (isSuperfunnelDemo) return 'https://superfunnel-demo.com';
  if (isQa1) return 'https://qa1.pray.com';
  if (isQa2) return PRODUCTION_API;
  // isDevelopment, isQa3, and unknown branches (feature/PR builds) → dev
  return 'https://dev.pray.com';
})();

// Whether this build talks to the production API. Not `isProduction`: qa-2 and demo-rollout builds talk to it too.
export const isProductionApi = SERVER_BASE_URI === PRODUCTION_API;

// --------------------------------------------------------------------------------------------
// America Prays Email Capture API Gateway
// --------------------------------------------------------------------------------------------
export const AMERICA_PRAYS_API_URL = (() => {
  if (isLocal) return 'https://vdiwx10xhi.execute-api.us-east-1.amazonaws.com/dev'; // No local equivalent — use dev API Gateway
  if (isDevelopment) return 'https://vdiwx10xhi.execute-api.us-east-1.amazonaws.com/dev';
  return 'https://9alwhckws2.execute-api.us-east-1.amazonaws.com/prod';
})();

// --------------------------------------------------------------------------------------------
// America Prays Prayer Capture API Gateway
// --------------------------------------------------------------------------------------------
export const AMERICA_PRAYS_PRAYER_API_URL = (() => {
  if (isLocal) return 'https://a55svxi4ee.execute-api.us-east-1.amazonaws.com/dev'; // Update after first deploy
  if (isDevelopment) return 'https://a55svxi4ee.execute-api.us-east-1.amazonaws.com/dev';
  return 'https://49xlhdi1gf.execute-api.us-east-1.amazonaws.com/prod';
})();

// --------------------------------------------------------------------------------------------
// Server JWT
// --------------------------------------------------------------------------------------------
export const SERVER_JWT =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiODAzYzhhMzAtZjA0ZC0xMWU5LWFlYWQtMzFkOGQwZDVkNjQ0IiwiYmlydGhkYXkiOm51bGwsImFnZSI6bnVsbCwiZ2VuZGVyIjpudWxsLCJzdHJlZXRfYWRkcmVzcyI6bnVsbCwiY2l0eSI6bnVsbCwic3RhdGUiOm51bGwsInppcGNvZGUiOm51bGwsImNvdW50cnkiOm51bGwsInByb2ZpbGVfaW1hZ2UiOm51bGwsImJhY2tncm91bmRfcHJvZmlsZV9pbWFnZSI6bnVsbCwic21zIjp0cnVlLCJtYXJrZXRpbmdfc21zIjp0cnVlLCJkZXN0cm95ZWQiOmZhbHNlLCJoYXNfYWNjZXB0ZWRfdG9zX3BwIjpmYWxzZSwicGFzc3dvcmQiOm51bGwsIl9pZCI6MjY3NzkyOCwidHlwZSI6ImJhc2ljIiwidXBkYXRlZF9hdCI6IjIwMTktMTAtMTZUMTk6NDU6MjYuMDAwWiIsImNyZWF0ZWRfYXQiOiIyMDE5LTEwLTE2VDE5OjQ1OjI2LjAwMFoifSwiaWF0IjoxNTcxMjU1MTI2LCJleHAiOjk1NzEyNTU3MjZ9.BfpihbYkqL2riV67pr2BEewMHULi_mXv4-RipNEoJOU';

// --------------------------------------------------------------------------------------------
// Web base URI
// --------------------------------------------------------------------------------------------
// Local: www's dev port. Defaults to 8001 so Studio (8000) and www (8001) run side by side;
// override with GATSBY_WEB_PORT / REACT_APP_WEB_PORT when www runs elsewhere.
const WEB_PORT = process.env.GATSBY_WEB_PORT || process.env.REACT_APP_WEB_PORT || process.env.WEB_PORT || 8001;

export const WEB_BASE_URI = (() => {
  if (isLocal) return `http://localhost:${WEB_PORT}`;
  if (isDevelopment) return 'https://development-www.pray.com';
  // demo-rollout falls through to the prod www host (matches CHAT_BASE_URI):
  // public links like Series Details "Playlist Link" must resolve to
  // www.pray.com, not studio.pray.com (the admin app, which doesn't serve them).
  if (isSuperfunnelDemo) return 'https://www.pray.com';
  if (isQa1) return 'https://qa-1-www.pray.com';
  if (isQa2) return 'https://qa-2-www.pray.com';
  if (isQa3) return 'https://qa-3-www.pray.com';
  return 'https://www.pray.com';
})();

// --------------------------------------------------------------------------------------------
// Chat base URI
// --------------------------------------------------------------------------------------------
// Public host that serves the embeddable chat (/embed/chat, /chat-widget). The chat is embedded
// on external partner sites and previewed inside Studio, so it must always resolve to a public
// www host — never studio.pray.com (the admin app, which doesn't serve these routes). Mirrors
// WEB_BASE_URI except demo-rollout/superfunnel-demo fall through to the prod www host.
export const CHAT_BASE_URI = (() => {
  if (isLocal) return `http://localhost:${WEB_PORT}`;
  if (isDevelopment) return 'https://development-www.pray.com';
  if (isQa1) return 'https://qa-1-www.pray.com';
  if (isQa2) return 'https://qa-2-www.pray.com';
  if (isQa3) return 'https://qa-3-www.pray.com';
  return 'https://www.pray.com';
})();

// --------------------------------------------------------------------------------------------
// Hotjar Properties for All Pray Web Apps
// --------------------------------------------------------------------------------------------
export const HOTJAR_WWW = {
  SITE_ID: 1071007,
  VERSION: 6,
};

export const HOTJAR_STUDIO = {
  SITE_ID: 6366785,
  VERSION: 6,
};

// --------------------------------------------------------------------------------------------
// Firebase
// --------------------------------------------------------------------------------------------
export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDAbCHUYUkbnDIZYYd7LEs_PlbDD6GjIyg',
  authDomain: 'fir-pray.firebaseapp.com',
  databaseURL: 'https://fir-pray.firebaseio.com',
  projectId: 'firebase-pray',
  storageBucket: 'firebase-pray.appspot.com',
  messagingSenderId: '917201567722',
  appId: '1:917201567722:web:fe9fd362d5c46eca36bc93',
  measurementId: 'G-8YXGTXYCLE',
};

// --------------------------------------------------------------------------------------------
// Giving Tips
// --------------------------------------------------------------------------------------------
export const TIP_MODEL_DEFAULTS = {
  PERCENTAGE: [
    { DISPLAY: '30%', MULTIPLIER: 0.3 },
    { DISPLAY: '19%', MULTIPLIER: 0.19 },
    { DISPLAY: '15%', MULTIPLIER: 0.15 },
  ],
  FLAT: [
    { DISPLAY: '$3.00', VALUE: 300 },
    { DISPLAY: '$2.00', VALUE: 200 },
    { DISPLAY: '$1.00', VALUE: 100 },
  ],
};

// --------------------------------------------------------------------------------------------
// Hubspot
// --------------------------------------------------------------------------------------------
export const HUBSPOT_FORM_SCRIPT = '//js.hsforms.net/forms/shell.js';

export const HUBSPOT_CONTACT_FORM = {
  region: 'na1',
  portalId: '2592247',
  formId: '456917eb-a535-4da9-91af-aac3b3f14799',
  inlineMessage:
    'Thank you for being interested in partnerships with us, someone from Pray will reach out to you shortly.',
};

export const HUBSPOT_PARTNER_FORM = {
  region: 'na1',
  portalId: '2592247',
  formId: '04eb4c72-7231-4326-9994-241b2c0209e2',
};

// --------------------------------------------------------------------------------------------
// Sparkloop
// --------------------------------------------------------------------------------------------
export const SPARKLOOP_TEAM_ID = 'team_f68beabaf3bb';

export const SPARKLOOP_PUBLICATION_ID = {
  AI_BIBLE: 'pub_881861174681',
  AMERICAN_CHRISTIAN: 'pub_c2eb5c37f9c0',
  BIBLE_IN_A_YEAR: 'pub_52282b6e782f',
  PRAY_DAILY_DEVOTIONAL: 'pub_6a0fb1520cb3',
  SLEEP_PSALMS: 'pub_707bd92b9aa9',
  THE_CHOSEN_PEOPLE: 'pub_f4ec964f8399',
};

// --------------------------------------------------------------------------------------------
// Fathom Analytics
// --------------------------------------------------------------------------------------------
export const FATHOM_SITE_ID = isProduction || isLocal ? 'SVJMQSNS' : null;
